module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive/clubpilates-46213bc77f7d8c2e09f5a1eb718666db.png";